import gsap from "gsap";

class Gallery {
  constructor() {
    this.galleries = document.querySelectorAll(".gallery-wrapper");
    this.config = [];
    this.activeSlideIndex = 0;
    this.activeSlide = {
      slide: 0,
      initialSlide: 0,
    };

    if (this.galleries && this.galleries.length > 0) {
      this.createPopup();
      this.createPopupContent();
      this.thumbAction();
    }
  }

  /**
   * Create popup wrapper
   */
  createPopup() {
    this.popupWrapper = document.createElement("div");
    this.popupWrapper.classList.add("popup-gallery-wrapper");
    document.body.appendChild(this.popupWrapper);
  }

  createPopupContent() {
    const arrow = `<svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 2" viewBox="0 0 20.99 36.93"><path fill="#ff6c22" d="M3.15 36.93 0 33.88l14.91-15.42L0 3.04 3.15 0l17.84 18.46z"/></svg>`;

    const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 2" viewBox="0 0 31.35 31.35"><path fill="#f7f7f7" d="M31.35 2.83 28.52 0 15.68 12.85 2.83 0 0 2.83l12.85 12.85L0 28.52l2.83 2.83L15.68 18.5l12.84 12.85 2.83-2.83L18.5 15.68z"/></svg>`;

    this.galleries.forEach((gall) => {
      const wrapper = document.createElement("div");
      const clone = gall.cloneNode(true);
      const figure = clone.querySelectorAll("figure");
      wrapper.classList.add("inner-wrapper");

      wrapper.innerHTML = `<div class="close-button"><div class="button stagger-item">${closeIcon}</div></div>`;
      wrapper.innerHTML += `<div class="popup-gallery stagger-item">${clone.innerHTML}</div>`;
      wrapper.innerHTML += `<div class="footer-gallery stagger-item">
          <div class="prev-next prev disabled">${arrow}</div>
          <div class="number">1 of ${figure.length}</div>
          <div class="prev-next next">${arrow}</div>
        </div>`;

      this.popupWrapper.appendChild(wrapper);

      this.config.push({
        i: 0,
        tl: gsap.timeline(),
        popupGallery: wrapper,
      });
    });
  }

  slideGallery() {
    const item = this.config[this.activeSlide.slide];
    const itemPopUp = item.popupGallery;
    item.i = this.activeSlide.initialSlide;

    if (itemPopUp) {
      const closeButton = itemPopUp.querySelector(".close-button .button");
      const prevNext = itemPopUp.querySelectorAll(".prev-next");
      const figure = itemPopUp.querySelectorAll("figure");
      const number = itemPopUp.querySelector(".number");
      const innerRect = itemPopUp.getBoundingClientRect();
      const galleryWrapper = itemPopUp.querySelector(".popup-gallery");

      const animate = () => {
        prevNext.forEach((b) => b.classList.remove("disabled"));
        number.innerHTML = `${this.activeSlideIndex + 1} of ${figure.length}`;

        const move = innerRect.width * this.activeSlideIndex;
        gsap.to(galleryWrapper, {
          x: move * -1,
          duration: 1,
          ease: "power4.inOut",
        });

        if (this.activeSlideIndex >= figure.length - 1) {
          prevNext[1].classList.add("disabled");
        }
      };

      animate();

      closeButton.onclick = () => {
        // Reset index active
        this.activeSlideIndex = 0;
        gsap.to(this.popupWrapper, {
          opacity: 0,
          duration: 0.6,
          ease: "power2.inOut",
          onComplete: () => {
            this.popupWrapper.classList.remove("active");
          },
        });
      };

      prevNext.forEach((button) => {
        button.onclick = () => {
          const isNext = button.classList.contains("next");

          if (isNext) {
            this.activeSlideIndex++;
          } else {
            this.activeSlideIndex--;
          }

          animate();

          if (this.activeSlideIndex === 0 && !isNext) {
            button.classList.add("disabled");
          }

          if (this.activeSlideIndex >= figure.length - 1 && isNext) {
            button.classList.add("disabled");
          }
        };
      });
    }
  }

  thumbAction() {
    this.galleries.forEach((item, index) => {
      const figures = item.querySelectorAll("figure");

      if (figures) {
        figures.forEach((thumb, j) => {
          thumb.addEventListener("click", () => {
            this.popupWrapper.classList.add("active");
            const gallery = this.config[index].popupGallery;

            this.activeSlideIndex = j;
            this.activeSlide.slide = index;

            this.slideGallery();

            this.config[index].tl
              .fromTo(
                this.popupWrapper,
                {
                  opacity: 0,
                },
                {
                  opacity: 1,
                  duration: 0.6,
                  ease: "power4.inOut",
                }
              )
              .fromTo(
                gallery.querySelectorAll(".stagger-item"),
                {
                  y: 20,
                  opacity: 0,
                },
                {
                  opacity: 1,
                  y: 0,
                  stagger: 0.1,
                  duration: 0.7,
                  ease: "power3.inOut",
                }
              );
          });
        });
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Gallery();
});
